import React, { useRef, useCallback } from "react";
import { getDisplayName } from "utils/hoc";

const makeScrolling =
  ({ refName, additionalSpaceOnTop = 5 } = {}) =>
  (WrappedComponent) => {
    const ScrollingComponent = (props) => {
      const wrappedRef = useRef(null);

      const getRef = useCallback(() => {
        if (wrappedRef.current && wrappedRef.current.refs) {
          return wrappedRef.current.refs[refName];
        }
      }, []);

      const scrollToTop = useCallback(() => {
        const refContainer = getRef(null);

        if (refContainer) {
          const refPosition =
            refContainer.getBoundingClientRect().top +
            window.scrollY -
            additionalSpaceOnTop;

          window.scrollTo({
            top: refPosition,
            left: 0,
            behavior: "smooth",
          });
        }
      }, [getRef, additionalSpaceOnTop]);

      return (
        <WrappedComponent
          {...props}
          ref={wrappedRef}
          scrollToTop={scrollToTop}
        />
      );
    };

    ScrollingComponent.displayName = `Scrolling${getDisplayName(
      WrappedComponent,
    )}`;

    return ScrollingComponent;
  };

export default makeScrolling;
